// The "Got questions?" row records what a visitor opened in the address bar, not
// anywhere else: each tap is appended to ?looking_for as "<step>:<entry>",
// entries joined by "|" (e.g. "3:Expanded|3:Reviews|4:Expanded"). Session
// replays keep the address, so the journey reads back from it; nothing is sent.
// The static Steps 1-2 write the same parameter in the same shape.
export function appendLookingFor(href, step, entry) {
  const url = new URL(href);
  const prev = url.searchParams.get('looking_for');
  url.searchParams.set('looking_for', `${prev ? `${prev}|` : ''}${step}:${entry}`);
  return url.toString();
}
